import { render, staticRenderFns } from "./DocumentRequestTypeSelectbox.vue?vue&type=template&id=cbcacd18"
import script from "./DocumentRequestTypeSelectbox.vue?vue&type=script&lang=js"
export * from "./DocumentRequestTypeSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports